var _g;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgProcessing = function SvgProcessing(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#373737",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M26 27.377C23.668 22.986 19.088 20 13.82 20 6.189 20 0 26.268 0 34v6M20 51.562L19.177 60H7.47L5.519 40H0M14 20v16.019"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 8,
    r: 8,
    stroke: "#373737"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 16,
    stroke: "#397431"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#397431",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M44 37v7h7"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#397431",
    fillRule: "nonzero",
    d: "M47 45v-6a1 1 0 0 0-2 0v7a1 1 0 0 0 1 1h7a1 1 0 0 0 0-2h-6zm-1 18c9.389 0 17-7.611 17-17s-7.611-17-17-17-17 7.611-17 17 7.611 17 17 17zm0-2c-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#373737",
    fillRule: "nonzero",
    d: "M15.82 21l.168.001-.016.001.2.002c5.378.128 10.202 3.178 12.711 7.904a1 1 0 0 1-1.766.938C25.08 26.011 21.292 23.454 17 23.055L17 38.019a1 1 0 0 1-1.993.116L15 38.02V23.026C8.405 23.45 3.16 28.928 3.004 35.69L3 36v4.999l4.52.002a1 1 0 0 1 .976.787l.018.116L10.377 61h9.893l.735-7.535a1 1 0 0 1 1.995.077l-.005.117-.823 8.438a1 1 0 0 1-.878.896l-.117.007H9.47a1 1 0 0 1-.977-.787l-.018-.116-1.863-19.096-4.595-.002L2 43a1 1 0 0 1-.993-.883L1 42v-6c0-8.281 6.632-15 14.82-15zm.232.001h-.064L16 21l.052.001zM16 1a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm0 2a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm-.18 18l.147.002h.005L15.821 21z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProcessing, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/processing.9c2c9850.svg";
export { ForwardRef as ReactComponent };